import { render } from "./Board.vue?vue&type=template&id=725e46ac&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"

import "./Board.vue?vue&type=style&index=0&id=725e46ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-725e46ac"

export default script